import { everyChecker } from './checkers/everyChecker'

export const settingsStringParsing = (str: string, defaults: any) => {
    const splitted = str.split(';')
    const newValues = defaults.map((item: any, i: number) => {
        if (item.name === 'custom') {
            return splitted[i]
        }
        return everyChecker[item.name](splitted[i], item.minStake && item.minStake, item.maxStake && item.maxStake)
    })
    return newValues
}